import DateSelector from '../../1elements/Fields/DateSelector'
import {Text} from '../../1elements'

const LastInspectionDatePicker = ({disabled, onChange, value}) => {
    return(
        <>
            <Text type={'fieldLabel'}>Last Inspection Date</Text>
            <DateSelector disabled={disabled} disableFuture onChange={onChange} value={value} />
        </>
    )
}

export default LastInspectionDatePicker